// extracted by mini-css-extract-plugin
module.exports = {"recoverAccountContainer":"RecoverAccountPage_recoverAccountContainer__15d__","recoverAccountTitle":"RecoverAccountPage_recoverAccountTitle__12mSp"};